export const CHECK_IN_COUNTER_KEY = 'checkInCounter'
export const LATEST_CHECK_IN_KEY = 'latestCheckIn'
export const MEGABYTES_IN_BYTES = 1024 * 1024
export const CHECK_IN_CONSTANTS = {
  minCharNeeded: 4,
}
export const MILESTONES = [0, 1, 5, 10, 25, 30, 45, 50, 100, 200, 250, 500, 750, 1000]
